// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "main." + {"71":"cd0460311ff1208dec55","80":"cd0460311ff1208dec55","132":"cd0460311ff1208dec55","363":"cd0460311ff1208dec55","449":"cd0460311ff1208dec55","855":"cd0460311ff1208dec55"}[chunkId] + ".min.css";
};